import type { Editor } from "@tiptap/core";
import { cn } from "cn";
import { memo, useCallback } from "react";
import { FormatButton } from "./format-button";

export const FormatToolBar = memo(function FormatToolBar({
  editor,
  className,
}: {
  editor: Editor;
  className?: string;
}) {
  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <div
      className={cn(
        /* sorted */
        "z-999",
        "p-1",
        "text-text-dark-max",
        "pointer-events-auto",
        className,
      )}
    >
      <div className="flex items-center gap-0.5" onMouseDown={handleMouseDown}>
        <FormatButton format="bold" editor={editor} />
        <FormatButton format="italic" editor={editor} />
        <FormatButton format="strike" editor={editor} />
        <FormatButton format="orderedList" editor={editor} />
        <FormatButton format="bulletList" editor={editor} />
        <FormatButton format="link" editor={editor} />
        <FormatButton format="clear" editor={editor} />
      </div>
    </div>
  );
});
